/* ====================================================================================================================
   RIZEN PDP BLOCKS — JS for sale timer (daily-resetting live countdown) and stock countdown.
   Runs on DOMContentLoaded and also re-runs after Shopify section renders (Theme Editor) and product re-renders.
==================================================================================================================== */
(function () {
  'use strict';

  function pad(n) { return String(n).padStart(2, '0'); }

  /* ---- SALE TIMER: counts down to the next local "reset hour" (default 24 = midnight), then rolls to next day ---- */
  function initSaleTimers(root) {
    var timers = (root || document).querySelectorAll('.rz-sale-timer');
    timers.forEach(function (el) {
      if (el.__rzTimerInit) return;
      el.__rzTimerInit = true;

      var resetHour = parseInt(el.getAttribute('data-reset-hour') || '24', 10);
      var hEl = el.querySelector('[data-h]');
      var mEl = el.querySelector('[data-m]');
      var sEl = el.querySelector('[data-s]');
      if (!hEl || !mEl || !sEl) return;

      function nextDeadline() {
        var now = new Date();
        var deadline = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
        if (resetHour >= 24) {
          deadline.setDate(deadline.getDate() + 1);
        } else {
          deadline.setHours(resetHour, 0, 0, 0);
          if (deadline.getTime() <= now.getTime()) {
            deadline.setDate(deadline.getDate() + 1);
          }
        }
        return deadline.getTime();
      }

      var deadline = nextDeadline();

      function tick() {
        var diff = deadline - Date.now();
        if (diff <= 0) {
          deadline = nextDeadline();
          diff = deadline - Date.now();
        }
        var total = Math.floor(diff / 1000);
        var h = Math.floor(total / 3600);
        var m = Math.floor((total % 3600) / 60);
        var s = total % 60;
        hEl.textContent = pad(h);
        mEl.textContent = pad(m);
        sEl.textContent = pad(s);
      }

      tick();
      el.__rzTimerInterval = setInterval(tick, 1000);
    });
  }

  /* ---- STOCK COUNTDOWN: real inventory already printed server-side; this only fills random mode + the bar ---- */
  function initStock(root) {
    var blocks = (root || document).querySelectorAll('.rz-stock');
    blocks.forEach(function (el) {
      if (el.__rzStockInit) return;
      el.__rzStockInit = true;

      var countEl = el.querySelector('[data-count]');
      var barEl = el.querySelector('[data-bar]');
      var count = countEl ? parseInt(countEl.textContent, 10) : 0;

      var isRandom = el.hasAttribute('data-random-min');
      if (isRandom && countEl) {
        var min = parseInt(el.getAttribute('data-random-min') || '3', 10);
        var max = parseInt(el.getAttribute('data-random-max') || '10', 10);
        count = Math.floor(Math.random() * (max - min + 1)) + min;
        countEl.textContent = count;
      }

      if (barEl) {
        var maxStock = isRandom ? 12 : Math.max(count + 4, 10);
        var pct = Math.max(8, Math.min(100, Math.round((count / maxStock) * 100)));
        barEl.style.width = (100 - pct) + '%';
      }
    });
  }

  function initAll(root) {
    initSaleTimers(root);
    initStock(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) { initAll(e.target); });
  document.addEventListener('product:rerendered', function () { initAll(document); });
})();